import { observer } from "mobx-react-lite";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useAuthStore } from "../hooks";
import { useTran } from "@/hooks";
import { Feature_NAMESPACES } from "@/lib/i18n";

export const SessionExpiredDialog = observer(() => {
  const { t } = useTran(Feature_NAMESPACES.AUTH);
  const authStore = useAuthStore();

  return (
    <Dialog open={authStore.showSessionExpired} onOpenChange={() => {}}>
      <DialogContent
        className="sm:max-w-md"
        onEscapeKeyDown={(event) => event.preventDefault()}
        onPointerDownOutside={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-rose-100 dark:bg-rose-900/20">
              <AlertTriangle className="h-5 w-5 text-rose-600 dark:text-rose-500" />
            </div>
            <DialogTitle>{t("auth.session.expiredTitle")}</DialogTitle>
          </div>
        </DialogHeader>

        <DialogDescription className="py-4">
          {authStore.sessionExpiredMessage ||
            t("auth.session.expiredDescription")}
        </DialogDescription>

        <DialogFooter>
          <Button type="button" onClick={authStore.confirmSessionExpired}>
            {t("auth.session.goToLogin")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
});

SessionExpiredDialog.displayName = "SessionExpiredDialog";
